import React, { useState } from "react";
import { useTranslation } from "react-i18next";
/// React router dom
import { Link } from "react-router-dom";
/// images
import logo from "../../../images/logo-activa.png";
import logoText from "../../../images/logo-text.png";

const NavHader = () => {
   const [toggle, setToggle] = useState(false);
   const { t } = useTranslation();
   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            <img className="logo-abbr" src={logo} alt="" />
            <img className="logo-compact" src={logoText} alt="" />
            <img className="brand-title" src={logoText} alt="" />
         </Link>

         <div className="nav-control" onClick={() => setToggle(!toggle)}>
            <div className={`hamburger ${toggle ? "is-active" : ""}`}>
               <span className="lines"></span>
               <span className="lines"></span>
               <span className="lines"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;
